module.exports = __webpack_public_path__ + "img/25.bddac5e5.jpg";